// Moglee Base — collection filtering.
//
// Two modes:
//   App filters  — desktop applies as you tick; mobile collects and applies on Apply.
//   Tag filters  — each choice is a URL, applied immediately, one per group.
// Both update the grid through Shopify's section rendering, and both fall back
// to a normal page load if anything fails.

(function () {
  var root = document.querySelector('[data-mb-collection]');
  if (!root) return;

  var sectionId = root.getAttribute('data-section-id');
  var pending = null;

  function render(url) {
    var grid = root.querySelector('[data-mb-grid]');
    if (grid) grid.setAttribute('aria-busy', 'true');
    if (pending) pending.abort();
    pending = new AbortController();

    var fetchUrl = url + (url.indexOf('?') === -1 ? '?' : '&') + 'section_id=' + sectionId;

    fetch(fetchUrl, { signal: pending.signal })
      .then(function (response) {
        if (!response.ok) throw new Error(response.status);
        return response.text();
      })
      .then(function (html) {
        var parsed = new DOMParser().parseFromString(html, 'text/html');
        var next = parsed.querySelector('[data-mb-collection]');
        if (!next) throw new Error('missing section');
        root.innerHTML = next.innerHTML;
        window.history.replaceState({}, '', url);
        bind();
      })
      .catch(function (error) {
        if (error.name === 'AbortError') return;
        window.location.href = url;
      })
      .finally(function () {
        var current = root.querySelector('[data-mb-grid]');
        if (current) current.removeAttribute('aria-busy');
      });
  }

  function openSheet(sheet) {
    sheet.setAttribute('data-open', 'true');
    document.body.style.overflow = 'hidden';
    var close = sheet.querySelector('[data-mb-sheet-close]');
    if (close) close.focus();
  }

  function closeSheet(sheet) {
    sheet.setAttribute('data-open', 'false');
    document.body.style.overflow = '';
  }

  function bind() {
    var form = root.querySelector('[data-mb-filter-form]');
    var sheet = root.querySelector('[data-mb-sheet]');
    var sheetForm = root.querySelector('[data-mb-sheet-form]');

    if (form) {
      form.addEventListener('change', function (event) {
        // Tag filters carry their own destination and apply straight away.
        if (event.target.hasAttribute('data-mb-tag-link')) return;
        var params = new URLSearchParams(new FormData(form));
        render(form.getAttribute('action') + '?' + params.toString());
      });
    }

    root.querySelectorAll('[data-mb-tag-link]').forEach(function (input) {
      input.addEventListener('change', function () {
        if (sheet) closeSheet(sheet);
        render(input.getAttribute('data-mb-tag-link'));
      });
    });

    root.querySelectorAll('[data-mb-sheet-open]').forEach(function (button) {
      button.addEventListener('click', function () {
        if (sheet) openSheet(sheet);
      });
    });

    root.querySelectorAll('[data-mb-sheet-close]').forEach(function (button) {
      button.addEventListener('click', function () {
        if (sheet) closeSheet(sheet);
      });
    });

    root.querySelectorAll('[data-mb-sheet-apply]').forEach(function (button) {
      button.addEventListener('click', function () {
        if (!sheetForm) return;
        var params = new URLSearchParams(new FormData(sheetForm));
        if (sheet) closeSheet(sheet);
        render(sheetForm.getAttribute('action') + '?' + params.toString());
      });
    });

    root.querySelectorAll('[data-mb-filter-link]').forEach(function (link) {
      link.addEventListener('click', function (event) {
        event.preventDefault();
        if (sheet) closeSheet(sheet);
        render(link.getAttribute('href'));
      });
    });
  }

  bind();

  document.addEventListener('keydown', function (event) {
    var sheet = root.querySelector('[data-mb-sheet][data-open="true"]');
    if (event.key === 'Escape' && sheet) closeSheet(sheet);
  });

  window.addEventListener('popstate', function () {
    render(window.location.href);
  });
})();
